import { NAME } from './constants';

export const COLLAPSE = `${NAME}.COLLAPSE`;
export const Collapse = (data) => ({
  type: COLLAPSE,
  payload: data,
});
